import Icon from './Icon';
import { ERRORS } from '../constants/content';

export default function CommonErrors() {
  return (
    <section className="section" id="errors">
      <div className="shell">
        <header className="section__head">
          <p className="kicker">What we fix</p>
          <h2>The accounting software problems we solve every day</h2>
          <p className="section__lede">
            Don’t see your error here? Send it to us anyway — our experts handle rare and
            unusual faults all the time, and the first check is always free.
          </p>
        </header>

        <div className="grid grid--3 error-grid">
          {ERRORS.map((item) => (
            <article className="card card--tile" key={item.title}>
              <span className="card__icon">
                <Icon name={item.icon} size={22} />
              </span>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
